export default __webpack_public_path__ + "static/media/quickstart_quide.3b665b78.png";